import { styled } from '@mui/system';

export const Errors = styled('div')({
	marginTop: '16px',
});

export const Actions = styled('div')({
	marginTop: '16px',
});
